import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

export const ACTION_FETCH_LIST_TREASURE = 'ACTION_FETCH_LIST_TREASURE';
export const REQUEST_FETCH_LIST_TREASURE = 'REQUEST_FETCH_LIST_TREASURE';
export const REQUEST_FETCH_LIST_TREASURE_SUCCESS = 'REQUEST_FETCH_LIST_TREASURE_SUCCESS';
export const REQUEST_FETCH_LIST_TREASURE_FAILURE = 'REQUEST_FETCH_LIST_TREASURE_FAILURE';
export const ACTION_UPDATE_FILTER_TREASURE = 'ACTION_UPDATE_FILTER_TREASURE';

export const ACTION_DELETE_TREASURE = 'ACTION_DELETE_TREASURE';
export const REQUEST_DELETE_TREASURE = 'REQUEST_DELETE_TREASURE';
export const REQUEST_DELETE_TREASURE_SUCCESS = 'REQUEST_DELETE_TREASURE_SUCCESS';
export const REQUEST_DELETE_TREASURE_FAILURE = 'REQUEST_DELETE_TREASURE_FAILURE';

const defaultState = {
  treasureFilter: {
    limit: 5,
    page: 1,
    q: '',
  },

  treasures: [],
  totalTreasure: 0,

  fetchTreasureLoading: false,
  fetchTreasureFailed: false,
  deleteTreasureLoading: false,
  deleteTreasureFailed: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_FETCH_LIST_TREASURE]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: true,
    fetchTreasureFailed: false,
  }),

  [REQUEST_FETCH_LIST_TREASURE_SUCCESS]: (state, action) => ({
    ...state,
    totalTreasure: action?.payload?.data?.total || 1,
    treasures: action?.payload?.data?.items || [],
    fetchTreasureLoading: false,
    fetchTreasureFailed: false,
  }),

  [REQUEST_FETCH_LIST_TREASURE_FAILURE]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: false,
    fetchTreasureFailed: true,
  }),

  [ACTION_UPDATE_FILTER_TREASURE]: (state, action) => ({
    ...state,
    treasureFilter: action.payload,
  }),

  [REQUEST_DELETE_TREASURE]: (state, _action) => ({
    ...state,
    deleteTreasureLoading: true,
    deleteTreasureFailed: false,
  }),

  [REQUEST_DELETE_TREASURE_SUCCESS]: (state, _action) => ({
    ...state,
    deleteTreasureLoading: false,
    deleteTreasureFailed: false,
  }),

  [REQUEST_DELETE_TREASURE_FAILURE]: (state, _action) => ({
    ...state,
    deleteTreasureLoading: false,
    deleteTreasureFailed: true,
  }),
});

export default reducer;
export const namespace = 'treasureManagement';

export const actionUpdateFilter = (filters) => ({
  type: ACTION_UPDATE_FILTER_TREASURE,
  payload: filters,
});

export const actionGetListTreasure = () => ({
  type: ACTION_FETCH_LIST_TREASURE,
});

export const actionDeleteTreasure = (id) => ({
  type: ACTION_DELETE_TREASURE,
  payload: id,
});

export const getListTreasureAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/campaigns/treasures',
    actionTypes: [
      REQUEST_FETCH_LIST_TREASURE,
      REQUEST_FETCH_LIST_TREASURE_SUCCESS,
      REQUEST_FETCH_LIST_TREASURE_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const deleteTreasureAPI = (id) => async (dispatch, getState) => {
  return await callAPI({
    method: 'delete',
    apiPath: `/campaigns/treasures/${id}`,
    actionTypes: [
      REQUEST_DELETE_TREASURE,
      REQUEST_DELETE_TREASURE_SUCCESS,
      REQUEST_DELETE_TREASURE_FAILURE,
    ],
    dispatch,
    getState,
  });
};
